import { render } from "./Ureshino.vue?vue&type=template&id=4186938e"
import script from "./Ureshino.vue?vue&type=script&lang=js"
export * from "./Ureshino.vue?vue&type=script&lang=js"

import "./Ureshino.vue?vue&type=style&index=0&id=4186938e&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__